import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { LanguageService } from '../../services/language.service';

@Component({
    selector: 'app-grid-section',
    templateUrl: './grid-section.component.html',
    styleUrls: ['./grid-section.component.css']
})
export class GridSectionComponent implements OnInit {
    @Input() title: string;
    @Input() dataSource: any[];
    @Input() columns: any[];
    @Input() hasShowButton = false;
    @Input() hasSearch = true;
    @Input() hasFilter = true;
    @Input() hasExport = true;
    @Input() hasGrouping = false;
    @Input() allowSelectAll = false;
    @Input() selectMode = "none";
    @Input() selectAllMode = "none";
    @Input() showCheckBoxesMode = "none";
    @Input() exportFileName: string;
    @Input() gridIsSelectable = true;
    @Input() groupItems: any[];
    @Input() storageKey: string = null;
    @Input() isLoading: boolean;

    @Output() rowClicked = new EventEmitter<any>();
  @Output() showClicked = new EventEmitter<void>();
  @Output() selectionChanged = new EventEmitter<any>();

    classes = '';

    constructor(public languageService: LanguageService) { }

    ngOnInit() {
        if (this.hasSearch && !this.hasGrouping)
            this.classes = 'with-search';

        if (!this.gridIsSelectable)
            this.classes += `${this.hasSearch ? ' ' : ''} grid-not-selectable`;

        if (this.storageKey)
            this.storageKey = `direct-desktop-grid-${this.storageKey}`;
    }

    exporting(e) {
        e.fileName = this.exportFileName;
    }

    onRowClicked(e) {
        this.rowClicked.emit(e);
    }

    onShowClicked() {
        this.showClicked.emit();
    }

  onSelectionChanged(e) {
    this.selectionChanged.emit(e.selectedRowsData);
  }
}
